<template>
  <article class="mobile-wrap">
    <header class="header flex justify-between">
      <div class="header-left">
        <img src="../../assets/images/mobile/logo.png" alt="" />
      </div>
      <div class="header-right flex justify-between">
        <a
          class="img1" 
          href="javascript:;" @click="statistics('go_lounge', 'lounge', 'https://game.naver.com/lounge/Blood_Witch/home')"
        >
          <img src="../../assets/images/mobile/btn_naverlounge.png" alt="" />
        </a>
      </div>
    </header>

    <section class="content">
      <!-- page1 -->
      <a name="page1"></a>
      <section class="page page1">
        <div class="link-box">
          <a
          href="javascript:;" @click="statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.r3.hhxxlkr.an')"
          class="gp"
          ><span class="light-effect"><i class="effect"></i></span
          ></a>
          <a href="javascript:;" @click="statistics('go_apple', 'apple', 'https://apps.apple.com/kr/app/id6475762323')"
          class="app"
            ><span class="light-effect"><i class="effect"></i></span
          ></a>
          <a href="javascript:;" @click="statistics('go_onestore', 'onestore', 'https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000773763')" class="one"
            ><span class="light-effect"><i class="effect"></i></span
          ></a>
          <a href="javascript:;" @click="statistics('go_galaxystore', 'galaxystore', 'https://galaxystore.samsung.com/detail/com.r3.hhxxl.samsung')"
            class="galaxy"
            ><span class="light-effect"><i class="effect"></i></span
          ></a>
        </div>
      </section>
      
      <!-- page5 -->
      <a name="page5"></a>
      <section class="page page5">
        <div class="swiper shopsSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../assets/images/mobile/slide_01.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/mobile/slide_02.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/mobile/slide_03.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/mobile/slide_04.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/mobile/slide_05.png" />
            </div>
          </div>
          <div class="pagination"></div>
        </div>
        <a href="javascript:;" class="btn-slide btn-prev"></a>
        <a href="javascript:;" class="btn-slide btn-next"></a>
      </section>
    </section>
  </article>
</template>

<script src="//cos-r2cdn-game-1259807850.cos.ap-beijing.myqcloud.com/gamesite/act_myheroes_day/js/swiper-bundle.min.js"></script>


<script>
  export default {
    name: "mobile",
    data() {
      return {
        sideSwiper: null,
        shopsSwiper: null,
      };
    },
    created() {
      ttq.load('COS7T0JC77UF1T0I40A0');
      ttq.page();
      fbq('init', '953854709205135');
      fbq('track', 'PageView');
    },
    mounted() {
      this.swiperFunc();
    },
    methods: {
      statistics(name, label, url) {
        gtag('event', name, {'event_label': label});
        // 新开链接跳转
        if (url) {
          window.open(url);
        }
      },
      swiperFunc() {
        this.shopsSwiper = new Swiper(".shopsSwiper", {
          // loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
          pagination: {
            el: ".pagination",
            clickable: true, //允许分页点击跳转
          },
        });

        this.sideSwiper = new Swiper(".sideSwiper", {
          loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 2000,
          },
          speed: 700,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 102rem;

    .header-left {
      width: 130rem;
      height: 130rem;
      margin-left: 10rem;

      img {
        width: 130rem;
        height: 130rem;
      }
    }

    .header-right {
      width: 75rem;
      margin-top: 20rem;

      img {
        width: 70rem;
        height: 70rem;
      }
    }
  }

  
  .link-box {
    width: 596rem;
    margin-left: 94rem;
    padding-top: 1092rem;

    .light-effect {
      width: 270rem;
      height: 73rem;
      margin-left: 5rem;
      margin-top: 4rem;
      border-radius: 6rem;
    }

    a {
      float: left;
      width: 280rem;
      height: 80rem;
      margin-right: 18rem;
      margin-bottom: 30rem;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .gp {
      background-image: url(../../assets/images/mobile/btn_gp.png);
    }

    .app {
      background-image: url(../../assets/images/mobile/btn_ios.png);
    }

    .one {
      background-image: url(../../assets/images/mobile/btn_one.png);
    }

    .galaxy {
      background-image: url(../../assets/images/mobile/btn_galaxy.png);
    }
  }

  // page1
  .page {
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .page1 {
    position: relative;
    height: 1348rem;
    background-image: url(../../assets/images/mobile/bg1.jpg);
  }

  @keyframes toDown {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(10rem);
    }

    100% {
      transform: translateY(0);
    }
  }

  .light-effect {
    position: relative;
    float: left;
    display: inline;
    overflow: hidden;

    .effect {
      position: absolute;
      top: 0;
      left: -100%;
      z-index: 2;
      width: 60%;
      height: 100%;
      background: linear-gradient(
        -45deg,
        transparent,
        transparent,
        rgba(255, 244, 227, 0.8),
        transparent,
        transparent
      );
      animation: animate-wipes 2s linear infinite;
    }
  }

  @keyframes animate-wipes {
    0% {
      left: -100%;
    }

    100% {
      left: 100%;
    }
  }

  @keyframes magnify {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.96);
    }
  }

  // 呼吸效果
  @keyframes breath {
    0% {
      transform: scale(0.95);
    }

    50% {
      transform: scale(1.05);
    }

    100% {
      transform: scale(0.95);
    }
  }

  .page5 {
    position: relative;
    height: 1155rem;
    margin-bottom: 190rem;
    background-image: url(../../assets/images/mobile/bg5.jpg);

    .swiper {
      width: 660rem;
      margin-top: 430rem;
    }

    .swiper-slide {
      width: 660rem;
      height: 380rem;

      img {
        width: 100%;
      }
    }

    .btn-slide {
      position: absolute;
      top: 590rem;
      z-index: 10;
      width: 42rem;
      height: 60rem;
      background: transparent;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .swiper-button-disabled {
      opacity: .35;
    }

    .btn-prev {
      left: 5rem;
      background-image: url(../../assets/images/mobile/btn_prev.png);
    }

    .btn-next {
      right: 5rem;
      background-image: url(../../assets/images/mobile/btn_next.png);
    }

    .pagination {
      padding-top: 40rem;
      text-align: center;
    }

    :deep(.swiper-pagination-bullet) {
      width: 28rem;
      height: 34rem;
      margin-left: 16rem;
      margin-right: 16rem;
      background: url(../../assets/images/mobile/page_un.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 0;
      opacity: 1;
      outline: none;
      border: none;

      &.swiper-pagination-bullet-active {
        background-image: url(../../assets/images/mobile/page_active.png);
      }
    }
  }
</style>
 